import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import ViewImageModal from './viewImageModal';

function ImageReadOnly(props) {
  const { member, imageUrls } = props;
  const [open, setOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  const getImageURL = memberValue => {
    if (imageUrls && imageUrls?.length > 0) {
      if (imageUrls.filter(x => x.componentName == memberValue).length > 0)
        return imageUrls.filter(x => x.componentName == memberValue)[0]
          .imageUrl;
      else return '';
    }
  };

  const handleEnlargeImage = imageUrl => {
    setOpen(true);
    setImageUrl(imageUrl);
  };

  const handleClose = () => {
    setOpen(false);
    setImageUrl('');
  };
  return (
    <>
      <Grid container>
        <Grid item lg={8} md={8}>
          <Typography sx={{ fontSize: '14px' }}>
            {member.valueDescription}
          </Typography>
        </Grid>
        {getImageURL(member?.value) && (
          <Grid item lg={4} md={4}>
            <div className="image-div">
              <img src={getImageURL(member?.value)} className="option-image" />
            </div>
          </Grid>
        )}
        {getImageURL(member?.value) && (
          <Grid item lg={12} md={12}>
            <div
              className="enlarge-image align-right"
              onClick={() => handleEnlargeImage(getImageURL(member?.value))}
            >
              Enlarge Image
            </div>
          </Grid>
        )}
      </Grid>
      {open && (
        <ViewImageModal
          open={open}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}
    </>
  );
}

export default ImageReadOnly;
